import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ApproachSection: React.FC = () => {
  const { translations } = useLanguage();
  
  return (
    <section className="py-20 bg-white" id="approach">
      <div className="container-custom">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3">
            <h2 className="text-navy mb-6">{translations.approach.title}</h2>
            <p className="mb-6 text-gray-800">
              {translations.approach.text}
            </p>
            <ul className="space-y-4 text-gray-800">
              {translations.approach.points.map((point, index) => (
                <li key={index} className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-light-blue mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2 relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <div 
                className="aspect-w-3 aspect-h-2 bg-gray-100"
                style={{
                  backgroundImage: "url('/images/SeaDent Team.jpg')",
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '400px'
                }}
                aria-label="SeaDent Mallorca Team"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection; 